import { InfoGrid, InfoRow } from '@/components';
import { useTranslation } from 'react-i18next';
import { contactDisplayName } from '../api';
import type { FieldSalesRepresentativeCompanyAndContact } from '../api';

interface FieldSalesRepresentativeCompanyContactItemProps {
  representative: FieldSalesRepresentativeCompanyAndContact;
}

/**
 * @component FieldSalesRepresentativeCompanyContactItem
 * @description Displays one field sales representative contact together with the company they belong to.
 *
 * @props
 *   representative (FieldSalesRepresentativeCompanyAndContact, required) - Company and contact pair returned by the customer endpoint.
 *
 * @changelog
 *   2026-07-08 - Initial creation.
 */
export function FieldSalesRepresentativeCompanyContactItem({
  representative,
}: FieldSalesRepresentativeCompanyContactItemProps) {
  const { t } = useTranslation();
  const contactName = contactDisplayName(representative.contact);

  return (
    // Card-like row for one representative assignment.
    <article className="border-border bg-surface rounded-lg border p-3">
      <InfoGrid className="grid-cols-1">
        <InfoRow
          label={t('companyAdmin.form.fieldSalesRepresentative.contact')}
          value={contactName}
        />
        <InfoRow
          label={t('companyAdmin.form.fieldSalesRepresentative.company')}
          value={representative.company.name}
        />
        <InfoRow
          label={t('companyAdmin.form.fieldSalesRepresentative.email')}
          value={representative.contact.email ?? '-'}
        />
        <InfoRow
          label={t('companyAdmin.form.fieldSalesRepresentative.phone')}
          value={representative.contact.phone_number ?? '-'}
        />
      </InfoGrid>
    </article>
  );
}
